export default __webpack_public_path__ + "static/media/overdue.0120bbff.svg";